<template>
  <div class="container" :class="containerClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'v-container',
  computed: {
    containerClass () {
      return this.$vuetify.breakpoint.name
    }
  }
}
</script>

<style lang="scss" scoped>
  /*.xs { margin: 0 20px; }*/
  /*.sm { margin: 0 40px; }*/
  /*.md { margin: 0 100px; }*/
  /*.lg { margin: 0 200px; }*/
  /*.xl { margin: 0px 300px; }*/
</style>
